import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { cdpAiStore } from '../../../stores/cdpAiStore';
import { MessageList } from './MessageList';
import { InputBar } from './InputBar';

export interface CopilotPanelProps { pageContext?: string; }

export const CopilotPanel = observer((props: CopilotPanelProps) => {
  const { t } = useTranslation('console-ai');
  if (!cdpAiStore.isPanelOpen) return null;
  return (
    <aside className="flex flex-col w-[340px] border-s border-white/10 bg-slate-900/40">
      <header className="flex items-center justify-between px-3 py-2 border-b border-white/10">
        <span className="text-sm font-semibold"><span aria-hidden="true">✨ </span>{t('panel.title')}</span>
        <button onClick={() => cdpAiStore.togglePanel()} className="text-xs opacity-60 hover:opacity-100">×</button>
      </header>
      <MessageList />
      <InputBar pageContext={props.pageContext} />
    </aside>
  );
});
